import React, { useState } from "react";
import useFormValidation from "./useFormValidation";
import FirebaseContext from "../../firebase/context";
import { Button, TextField, Grid, Container, Paper } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';
import validatePerfil from "./validatePerfil";
import UploadFoto from "./UploadFoto";

const style = {
    paper: {
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    form: {
        width: "100%",
        marginTop: 20
    },
    submit: {
        marginTop: 15,
        marginBottom: 20
    },
    avatar: {
        margin: 10,
        width: 100,
        height: 100

    }
};

const PerfilUsuarioEdit = (props) => {

    const { firebase, user } = React.useContext(FirebaseContext);
    
    const [fotoURL, setFotoURL] = useState("")
    const INITIAL_STATE = {
        id: props.userDB.id,
        nombre: props.userDB.nombre,
        apellido: props.userDB.apellido,
        email: props.userDB.email,
        telefono: props.userDB.telefono,
        fotoUrl: props.userDB.fotoUrl,
    };

    const { handleSubmit, handleChange, values, errors } = useFormValidation(
        INITIAL_STATE,
        validatePerfil,
        handleUpdateUser
    ); 
    console.log('values');
    console.log(values);
    let userId = user.uid

    function handleUpdateUser() { 
            const { id, nombre, apellido, email, telefono} = values;
            const fotoUrl =   fotoURL        
            const editUsuario = {
                id,
                nombre,
                apellido,
                email,
                telefono,
                fotoUrl
            }; 
            console.log('editUsuario');
            console.log(user);
            
            firebase.db.collection("colUsuarios").doc(userId).set(editUsuario, { merge: true });
            props.setUpdateUser(true);
            props.setEnableEdit(false);
            const newUser = user.updateProfile({
                displayName: nombre,
                photoURL: fotoUrl 
           })  
    }

    return (
        <Container style={style.cardGrid}>
                <Paper style={style.paper}>
        <Grid>

                    <form onSubmit={handleSubmit} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Nombre"
                            name="nombre"
                            margin="normal"
                            placeholder="Nombre"
                            autoComplete="off"
                            type="text"
                            onChange={handleChange}
                            className={errors.nombre && "error-input"}
                            value={values.nombre}
                        />
                        {errors.tituloTema && <p className="error-text">{errors.tituloTema}</p>}
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Apellido"
                            name="apellido"
                            margin="normal"
                            placeholder="Apellido"
                            autoComplete="off"
                            type="text"
                            onChange={handleChange}
                            className={errors.apellido && "error-input"}
                            value={values.apellido}
                        />
                        {errors.apellido && <p className="error-text">{errors.video}</p>}
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Telefono"
                            name="telefono"
                            margin="normal"
                            placeholder="Telefono"
                            autoComplete="off"
                            type="text"
                            onChange={handleChange}
                            className={errors.telefono && "error-input"}
                            value={values.telefono}
                        />
                        {fotoURL}
                        {errors.telefono && <p className="error-text">{errors.telefono}</p>}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            className="button"
                            type="submit"
                            startIcon={<CheckIcon />}
                        >
                            ACTUALIZAR
                               </Button>
                        <Button
                            variant="contained"
                            color="error"
                            size="small"
                            type="button"
                            onClick={() => props.setEnableEdit(false)}
                            startIcon={<CancelIcon />}
                        >
                            CANCELAR
                               </Button>
                    </form>

                    {/* <Typography >URL de foto: {practicaURL}</Typography> */}
                    <UploadFoto setFotoURL={setFotoURL} />
        </Grid>
        </Paper>
        </Container>

    );
}

export default PerfilUsuarioEdit
